/* eslint-disable */
export default {
  callerCall: '主叫者',
  transferCall: '转接',
} as const;

// @key: @#@"callerCall"@#@ @source: @#@"Caller"@#@
// @key: @#@"transferCall"@#@ @source: @#@"Transfer"@#@
